module.exports = __webpack_public_path__ + "static/img/produce11.e726140.png";


//////////////////
// WEBPACK FOOTER
// ./src/module/technology/images/produce11.png
// module id = 141
// module chunks = 4